/**
 * Step constants - browser-safe, zero imports.
 * This is the foundation file that other step files build upon.
 */
const stepPlanRepetitionModes = {
    TEMPLATE: 'template',
    EXPLICIT: 'explicit',
};
export { stepPlanRepetitionModes };
//# sourceMappingURL=step.constants.js.map